export default "__VITE_ASSET__DHi5uzCz__"